import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingDirections, OrderingOption } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { accountIdChange } from 'src/app/store/select-account/select-account.actions';
import { ExtensionGroupRegisterOptions } from '../models/extension-register-options';
import { ExtensionGroupRegisterListItem } from '../models/extension-register-results.model';
import { ExtensionGroupsFilterOption } from '../models/extensions-group-filter-option';
import * as extensionGroupRegisterActions from './extension-group-register.actions';
import {
   extensionGroupRegisterAdapterActions,
   extensionGroupRegisterInitialFilter,
} from './extension-group-register.actions';

export const extensionGroupRegisterFeatureKey = 'extensionGroupRegister';

export interface ExtensionGroupRegisterState
   extends RegisterState<ExtensionGroupRegisterListItem, ExtensionGroupRegisterOptions, OrderingOption> {
   filters: ExtensionGroupsFilterOption[];
}

const adapter: RegisterAdapter<ExtensionGroupRegisterListItem, ExtensionGroupRegisterOptions, OrderingOption> =
   createRegisterAdapter<ExtensionGroupRegisterListItem, ExtensionGroupRegisterOptions, OrderingOption>({
      selectId: (extensionGroupRegisterItem) => {
         return extensionGroupRegisterItem.extensionGroupId ?? 0;
      },
   });

export const initialState: ExtensionGroupRegisterState = {
   ...adapter.getInitialState(),
   ...adapter.getInitialState(),
   filters: [],
   orderingOptions: [{ direction: OrderingDirections.Asc, field: 'name' }],
};

export const extensionGroupRegisterReducer = adapter.createReducer(
   extensionGroupRegisterActions.extensionGroupRegisterAdapterActions,
   initialState,
   on(extensionGroupRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(extensionGroupRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         extensions: action.items,
         hasNextPage: action.hasNextPage,
         totalCount: action.totalCount,
      };
   }),
   on(extensionGroupRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         filters: action.filters,
      };
   }),
   on(extensionGroupRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...state.quickFilters,
            ...action.quickFilters,
         },
      };
   }),
   on(extensionGroupRegisterActions.extensionGroupRegisterAdapterActions.orderingOptionsChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         orderingOptions: state.orderingOptions
            ? [
                 ...state.orderingOptions
                    .filter((option) => !action.orderingOptions.some((newOption) => newOption.field === option.field))
                    .filter((option) => option.direction !== OrderingDirections.NotSet),
                 ...action.orderingOptions,
              ]
            : action.orderingOptions,
      };
   }),
   on(accountIdChange, (state, action) => {
      return {
         ...state,
         quickFilters: null,
      };
   })
);
export const extensionRegisterSelector = createFeatureSelector<ExtensionGroupRegisterState>(
   extensionGroupRegisterFeatureKey
);
export const selectors = adapter.getSelectors(extensionRegisterSelector);
export const {
   selectAll,
   selectCallState,
   selectTotalCount,
   selectQuickFilters,
   selectEndCursor,
   selectOrderingOptions,
} = adapter.getSelectors(extensionRegisterSelector);
